var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{staticStyle:{"min-width":"1450px !important"}}),(_vm.showCallReminder)?_c('div',[_c('callReminder',{attrs:{"callNumber":_vm.callNumber,"callTime":_vm.callTime},on:{"close":function($event){_vm.showCallReminder = false}}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }